import React from "react";
import {connect} from "react-redux";
import {loginRedirectCheckData} from "store/reducer/auth/selectors";
import {AppAreasRedirects, calculateRedirectBasedOnAuth} from "services/utils/utils";
import {Redirect} from "react-router";

const Guard = (Component, area) => {
    /* istanbul ignore next */
    const mapStateToProps = state => ({
        checkData: loginRedirectCheckData(state)
    });
    const GuardComponent = (props) => {
        React.useEffect(() => {
            window.scrollTo(0, 0);
        }, [props.location.pathname]);
        const {checkData} = props;
        if (checkData.loaded) {
            const redirect = calculateRedirectBasedOnAuth(checkData);
            if(redirect !== area) {
                return <Redirect to={redirect} />;
            }
        }
        return <Component {...props} />;
    }

    return connect(mapStateToProps)(GuardComponent);
}

export const LoggedOutGuard = (Component) => Guard(Component, AppAreasRedirects.LoggedOut);
export const LoggedInGuard = (Component) => Guard(Component, AppAreasRedirects.LoggedIn);
export const OnboardingGuard = (Component) => Guard(Component, AppAreasRedirects.Onboarding);
